import { polyfill } from "es6-promise";
polyfill();

import Vue from "vue";
import Vuex from "vuex";

const state = {
  page_state: 0, //possible values: 0, 1, 2, 21 (21 is mobile)
  popup_state: "",
  popup_video_src: "",
  can_skip_videos: true,
  popup_img_src: "",
  unity_progress: 0,
  unity_info: "",
  form_status: 0,
  contact_form_status: 0,

  ambience_volume: 0.17,
  ambience_max_volume: 0.17,
  ambience_current_vol: 0,
  ambience_previous_vol: -1,
  voice_volume: 1,

  instructions_shown: false,

  sections: [
    {
      name: "Oncology",
      id: "0",
      display_in_bar: true,
      display_in_footer: false,
      popup_type: "external_link",
      has_voiceover: false,
      voiceover_has_played: false
    }
  ],

  sections_content: {
    event_info: {
      tag: "commercial"
    },
    content: {
      subids: {
        patient_resources: {
          type: "pdf_slideshow",
          title: "Patient Resources",
          list: [
            {
              thumb: "Patient_Brochure_thumb.jpg",
              title: "Patient Brochure",
              type: "slideshow",
              filename_prefix: "1_PatientBrochure/Patient_Brochure_",
              count: 52,
              filetype: "jpg",
              slide_ratio: 1024 / 1024
            },
            {
              thumb: "Patient-Access-Brochure-thumb.jpg",
              title: "Patient Access Brochure",
              type: "slideshow",
              filename_prefix:
                "2_PatientAccessBrochure/Patient-Access-Brochure-",
              count: 4,
              filetype: "jpg",
              slide_ratio: 1024 / 1024
            }
          ]
        },
        patient_profiles: {
          type: "pdf_slideshow",
          title: "Patient Profiles",
          list: [
            {
              thumb: "Diane_thumb.jpg",
              title: "Patient Profile - Diane",
              type: "slideshow",
              filename_prefix: "1_Diane/Diane-",
              count: 2,
              filetype: "jpg",
              slide_ratio: 1024 / 791
            },
            {
              thumb: "Gregory_thumb.jpg",
              title: "Patient Profile - Gregory",
              type: "slideshow",
              filename_prefix: "2_Gregory/Gregory-",
              count: 2,
              filetype: "jpg",
              slide_ratio: 1024 / 791
            }
          ]
        },
        /*pi: {
          name: "Prescribing Information",
          type: "slideshow",
          filename_prefix: "INQOVI_Prescribing_Information-",
          count: 22,
          filetype: "jpg",
          slide_ratio: 1080 / 835
        },*/
        isi: {
          name: "Important Safety Information",
          type: "image",
          src: "ISI.jpg"
        },
        top: {
          name: "Slideshow",
          type: "slideshow",
          filename_prefix: "TaihoSS-",
          count: 4,
          filetype: "jpg",
          slide_ratio: 754 / 1920
        },
        about_INQOVI: {
          name: "",
          type: "iframe",
          src: "static/content/content/inqovi/"
        },
        healthcare_provider_resources: {
          type: "pdf_slideshow",
          title: "Healthcare Provider Resources",
          list: [
            {
              thumb: "Nurse_Guide-thumb.jpg",
              title: "Nurse Guide",
              type: "slideshow",
              filename_prefix: "1_nurseGuide/Nurse_Guide-",
              count: 50,
              filetype: "jpg",
              slide_ratio: 1024 / 768
            },
            {
              thumb: "Pharmacy_Guide_thumb.jpg",
              title: "Pharmacy Guide",
              type: "slideshow",
              filename_prefix: "2_pharmGuide/Pharmacy_Guide_",
              count: 54,
              filetype: "jpg",
              slide_ratio: 1024 / 768
            }
            // {
            //   thumb: "Community-ONC-Leave-Behind-thumb.jpg",
            //   title: "Community ONC Leave Behind",
            //   type: "slideshow",
            //   filename_prefix: "3_communityONCLeaveBehind/Community-ONC-Leave-Behind-",
            //   count: 6,
            //   filetype: "jpg",
            //   slide_ratio: 683 / 1024,
            // }
          ]
        }
      }
    }
  },

  footer_additional_links: [
    {
      type: "submenu",
      title: "Taiho Pipeline",
      href: "#",
      menu: [
        {
          type: "popup",
          href: ["menu", "pipeline1"],
          title: "Pipeline Deck"
        },

        {
          type: "external_link",
          href: "static/content/menu/Med Affairs Pipeline Flashcard.pdf",
          title: "Pipeline Flashcard"
        }
      ]
    },
    {
      type: "external_link",
      title: "Futibatinib Abstracts",
      href:
        "static/content/menu/ESMO 2020 Abstract Reference List_Final_09Sep2020.pdf"
    },
    {
      type: "external_link",
      title: "Medical Information",
      href: "https://taihomedicalinformation.com/"
    }
  ],

  current_section: "",
  current_sub_section: "",

  current_secondary_section: "",
  current_secondary_sub_section: "",

  app_state: -1,
  initial_movement_mode: "AUTO",
  app_type: "mobile",

  booth_form: {
    name: "",
    lastname: "",
    email: "",
    country: "",
    specialty: ""
  },

  browser: null,
  browser_is_mobile: false,

  intro_video_done: false,

  //general site options, be careful with this
  site_config: {
    use_intro_image: false,
    use_intro_video: false,
    use_intro_form: false,
    use_footer_as_links: true,
    validate_form: true,
    fake_mobile: false
  }
};

const mutations = {
  SET_PAGE_STATE(state, val) {
    state.page_state = val;
  },
  SET_POPUP_STATE(state, val) {
    console.log("set_popup_state", val);
    state.popup_state = val;
  },
  SET_UNITY_PROGRESS(state, val) {
    state.unity_progress = val;
  },
  SET_UNITY_INFO(state, val) {
    state.unity_info = val;
  },
  SET_FORM_STATUS(state, val) {
    state.form_status = val;
  },
  SET_CONTACT_FORM_STATUS(state, val) {
    state.contact_form_status = val;
  },
  SET_VIDEO_POPUP(state, val) {
    state.popup_video_src = val;
    state.popup_state = "video";
  },
  SET_IMAGE_POPUP(state, val) {
    state.popup_img_src = val;
    state.popup_state = "image";
  },
  SET_SLIDESHOW_POPUP(state, val) {
    state.popup_video_src = val;
    state.popup_state = "slideshow";

    console.log(state);
  },
  SET_LINKS_POPUP(state, val) {
    state.popup_video_src = val;
    state.popup_state = "links";
  },
  SET_CONTACT_POPUP(state, val) {
    state.popup_video_src = val;
    state.popup_state = "form";
  },
  SET_ACTIVE_SECTION(state, val) {
    console.log("setting active section to ", val);
    state.current_section = val + "";
    state.current_secondary_section = "";
  },
  SET_ACTIVE_SUB_SECTION(state, val) {
    console.log("setting active subsection to ", val);
    state.current_sub_section = val + "";
    state.current_secondary_sub_section = "";
  },
  SET_SECONDARY_SECTION(state, val) {
    state.current_secondary_section = val.section;
    state.current_secondary_sub_section = val.sub_section;
  },
  SET_APP_STATE(state, val) {
    state.app_state = val;
  },

  SET_SIMPLE_VAL(state, obj) {
    state[obj.name] = obj.val;
  },
  SAVE_BOOTH_FORM(state, obj) {
    state.booth_form = JSON.parse(JSON.stringify(obj));
    state.form_status = 1;
  },

  SAVE_INITIAL_MOVEMENT_FORM(state, app_mode) {
    state.initial_movement_mode = app_mode;
    console.log("initial app mode", state.initial_movement_mode);
  },

  SET_BROWSER_IDENTITY(state, browser) {
    state.browser = browser;
  },

  SET_VOICEOVER_PLAYED(state, section) {
    state.sections.forEach((item, idx) => {
      //other voiceover might be playing so let's stop them
      if (item.has_voiceover && item.id == section + "") {
        item.voiceover_has_played = true;
      }
    });
  }
};

const actions = {
  set_page_state({ commit }, val) {
    commit("SET_PAGE_STATE", val);
  },
  set_popup_state({ commit }, val) {
    commit("SET_POPUP_STATE", val);
  },
  set_video_popup({ commit }, val) {
    commit("SET_VIDEO_POPUP", val);
  },

  set_image_popup({ commit }, val) {
    commit("SET_IMAGE_POPUP", val);
  },
  set_slideshow_popup({ commit }, val) {
    commit("SET_SLIDESHOW_POPUP", val);
  },
  set_links_popup({ commit }, val) {
    commit("SET_LINKS_POPUP", val);
  },
  set_contact_popup({ commit }, val) {
    commit("SET_CONTACT_POPUP", val);
  },
  set_unity_progress({ commit }, val) {
    commit("SET_UNITY_PROGRESS", val);
  },
  set_unity_info({ commit }, val) {
    commit("SET_UNITY_INFO", val);
  },
  set_current_section({ commit }, val) {
    commit("SET_ACTIVE_SECTION", val);
  },
  set_current_subsection({ commit }, val) {
    commit("SET_ACTIVE_SUB_SECTION", val);
  },
  //should have val.section and val.sub_section
  set_secondary_section({ commit }, val) {
    commit("SET_SECONDARY_SECTION", val);
  },
  set_app_state({ commit }, val) {
    commit("SET_APP_STATE", val);
  },
  set_simple_val({ commit }, obj) {
    commit("SET_SIMPLE_VAL", obj);
  },
  set_browser_identity({ commit }, obj) {
    commit("SET_BROWSER_IDENTITY", obj);
  },
  set_voiceover_played({ commit }, obj) {
    commit("SET_VOICEOVER_PLAYED", obj);
  },
  submit_form({ commit }, data) {
    if ("undefined" != typeof data.skip_form && data.skip_form == true) {
      commit("SAVE_INITIAL_MOVEMENT_FORM", data.app_mode);
      commit("SET_FORM_STATUS", 1);
      setTimeout(
        function () {
          commit("SET_FORM_STATUS", 2);
          commit("SET_PAGE_STATE", 2);
        }.bind(this),
        2000
      );
      return;
    }

    const axios = require("axios");

    commit("SET_FORM_STATUS", 1);
    commit("SAVE_BOOTH_FORM", data);
    commit("SAVE_INITIAL_MOVEMENT_FORM", data.app_mode);
    let axiosConfig = {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      "Access-Control-Allow-Origin": "*"
    };

    axios({
      method: "post",
      url: "/form.php",
      // url: "https://audentes.protoexpo.com/form.php",
      headers: {
        "Content-Type": "application/json"
      },
      data: data
    })
      .then(function (response) {
        commit("SET_FORM_STATUS", 2);
        commit("SET_PAGE_STATE", 2);
      })
      .catch(function (error) {
        console.log(error);
        commit("SET_FORM_STATUS", 2);
        commit("SET_PAGE_STATE", 2);
      });
  },
  set_contact_form_status({ commit }, data) {
    commit("SET_CONTACT_FORM_STATUS", data);
  },

  submit_photo_data({ commit }, data) {
    const axios = require("axios");
    const config = {
      headers: { "content-type": "multipart/form-data" }
    };
    console.log(data);
    return new Promise((resolve, reject) => {
      axios
        .post("/", data, config)
        .then((response) => {
          console.log(response.data);
          resolve();
        })
        .catch((error) => reject());
    });
  },

  submit_contact_form({ commit }, data) {
    const axios = require("axios");

    commit("SET_CONTACT_FORM_STATUS", 1);
    // setTimeout(() => {
    //   commit("SET_CONTACT_FORM_STATUS", 2);
    // }, 4000);
    // console.log(data);

    axios({
      method: "post",
      url: "https://fkabi.protoexpo.com/contactform/process-contact-form.php",
      // url: "http://100.50.20.65/contact/data",
      headers: {
        "Content-Type": "application/json"
      },
      data: data
    })
      .then(function (response) {
        commit("SET_CONTACT_FORM_STATUS", 2);
      })
      .catch(function (error) {
        console.log(error);
        commit("SET_CONTACT_FORM_STATUS", 3);
      });
  }
};

const getters = {
  appBarSections: (state) => {
    return state.sections.filter((section) => section.display_in_bar);
  },
  footerBarSections: (state) => {
    return state.sections.filter((section) => section.display_in_footer);
  },
  getSection: (state) => {
    return (section_id) => {
      let section = null;
      state.sections.forEach((item) => {
        if (item.id == section_id) {
          section = item;
        }
      });
      return section;
    };
  },
  sectionContent: (state) => {
    return (section_id) => {
      return state.sections_content[section_id];
    };
  },
  sectionCount: (state) => {
    return state.sections.length;
  },
  eventTag: (state) => {
    return state.sections_content.event_info.tag;
  }
};

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  strict: process.env.NODE_ENV !== "production"
});



// WEBPACK FOOTER //
// ./src/store/index.js